module.exports = require("TweenMax");;